module.exports = __webpack_public_path__ + "static/media/step3_es.d0fc98d5.png";